module.exports = __webpack_public_path__ + "static/media/TUNE_1500.21ff144f.jpg";